import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ChooseState } from '../../create-block/create-block.model';

const getLabels = () => ({
  connext: 'Connext',
  others: 'Others',
  verifiedPlant: 'Verified Plant',
  legacyPlant: 'Legacy Plant',
  azzurroHub: 'Azzurro Hub',
});

@Component({
  selector: 'customer-choice-with-img',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './choice-with-img.component.html',
  styleUrls: ['./choice-with-img.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChoiceWithImgComponent {
  @Input() loggers: ChooseState[] = [];

  readonly _labels = getLabels();
  @Input() set labels(value: Partial<typeof this._labels>) {
    Object.assign(this._labels, value);
  }
  get labels(): typeof this._labels {
    return this._labels;
  }

  @Output() interaction = new EventEmitter<void>();
}
